/**
 * Read the paging block off a list response.
 *
 * The API answers in two shapes — `meta: { page, limit, total, totalPages }`
 * and `pagination: { page, limit, total, pages }` — depending on which route
 * you ask. Rather than teach every screen both, they are reconciled once here.
 */
export interface PageInfo {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export function readPagination(response: any): PageInfo | null {
  const raw = response?.meta ?? response?.pagination;
  if (!raw) return null;

  const page = Number(raw.page) || 1;
  const limit = Number(raw.limit) || 0;
  const total = Number(raw.total) || 0;
  const pages = Number(raw.pages ?? raw.totalPages) || 0;
  if (!limit || !pages) return null;

  return { page, limit, total, pages };
}
